import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA9JAaR6ObvFrYqJScdvb67ROtH5Bqe-nE",
  authDomain: "dashboard-mexico-for-sure.firebaseapp.com",
  projectId: "dashboard-mexico-for-sure",
  storageBucket: "dashboard-mexico-for-sure.appspot.com",
  messagingSenderId: "316684605625",
  appId: "1:316684605625:web:c683156a6e331c16d52368",
};

firebase.initializeApp(firebaseConfig);

export const firebaseFirestore = firebase.firestore();
export const firebaseAuth = firebase.auth();
export const firebaseStorage = firebase.storage().ref();
export const firebaseDatabase = firebase.database();
export { firebase };
